<div class="calculator__toggles uslugi">
  <div class="uslugi__area">
    <el-form-item prop="services.returnOfDocuments" class="calculator__toggle">
      <div class="calculator__toggle-title">Перевозка в тепле<span class="question" data-text=""></span></div>
      <el-switch @change="warmPlaceChangeTab" :disabled="checkWarmTab()" v-model="dataForm.cargoOtherTabs[getOtherKey(cargoSpaceTab.name)].warmPlace"/>
    </el-form-item>
    <el-form-item prop="services.returnOfDocuments" class="calculator__toggle">
      <div class="calculator__toggle-title">Возврат документов<span class="question" data-text=""></span></div>
      <el-switch v-model="dataForm.services.returnOfDocuments"/>
    </el-form-item>
  </div>
</div>
<div class="calculator__toggles uslugi">
  <div class="uslugi__area uslugi__area_type_switch-with-input">
    <el-form-item>
      <el-form-item prop="services.cashOnDelivery" class="calculator__toggle">
        <div class="calculator__toggle-title">Наложенный платеж<span class="question" data-text=""></span></div>
        <el-switch v-model="dataForm.services.cashOnDelivery"
          :disabled="checkCashOnDeliveryTab()" />
      </el-form-item>
    </el-form-item>
    <el-form-item class="uslugi__input uslugi__input_add_label" :disabled="dataForm.services.cashOnDelivery" v-if="dataForm.services.cashOnDelivery">
      <div class="uslugi__label">Сумма наложенного платежа</div>
      <el-form-item  class="calculator__toggle-input"
        prop="services.cashOnDeliverySum" :required="dataForm.services.cashOnDelivery">
        <el-input type="number" v-model="dataForm.services.cashOnDeliverySum"
          :disabled="!dataForm.services.cashOnDelivery" />
      </el-form-item>
    </el-form-item>
  </div>
  <div class="uslugi__area uslugi__area_type_switch-with-input uslugi__area_type_multi-input uslugi__area_margin_bottom">
    <el-form-item>
      <el-form-item prop="services.cargoRedemption" class="calculator__toggle">
        <div class="calculator__toggle-title">Выкуп груза<span class="question" data-text=""></span></div>
        <el-switch v-model="dataForm.services.cargoRedemption"
          :disabled="dataForm.services.cashOnDelivery" />
      </el-form-item>
    </el-form-item>

    <el-form-item class="uslugi__inputs margin-bottom--40">
      <el-form-item class="uslugi__input uslugi__input_add_label" :disabled="dataForm.services.cargoRedemption" v-if="dataForm.services.cargoRedemption">
        <div class="uslugi__label">Сумма выкупа груза:</div>
        <el-form-item class="calculator__toggle-input"
          prop="services.cargoRedemptionSum" :required="dataForm.services.cargoRedemption">
          <el-input type="number" v-model="dataForm.services.cargoRedemptionSum"
            :disabled="!dataForm.services.cargoRedemption" min="0"
            :max="dataForm.services.whoPaysTheRansom === '1' ? '6000' : ''"
            @change="checkRedemption('cargoRedemptionSum')" />
        </el-form-item>
      </el-form-item>
      <div class="block__notice block__notice-releative" v-if="dataForm.services.cargoRedemption">
        от 3 000 до 20 000 ₽
      </div>
      <el-form-item class="uslugi__input uslugi__input_add_label" :disabled="dataForm.services.cargoRedemption" v-if="dataForm.services.cargoRedemption">
        <div class="uslugi__label">За счет:</div>
        <el-form-item class="calculator__toggle-input"
          prop="services.whoPaysTheRansom" :required="dataForm.services.cargoRedemption">
          <el-select v-model="dataForm.services.whoPaysTheRansom" placeholder="Выберите вариант"
            :disabled="!dataForm.services.cargoRedemption" @change="checkRedemption('whoPaysTheRansom')"
            class="uslugi__input uslugi__input_add_label">
            <el-option v-for="option in optionsWhoPaysTheRansom" :key="option.value" :label="option.label"
              :value="option.value"
              :disabled="dataForm.sender.cityFrom !== 'Челябинск' && option.label === 'За счет ТК ЛУЧ'" />
          </el-select>
        </el-form-item>
      </el-form-item>
      <el-form-item>
        <span v-show="dataForm.services.whoPaysTheRansom === '1' && dataForm.services.cargoRedemption" class="label_font-size--10">
          *Город выкупа груза - Челябинск, до 6000 р., заказчик -
          получатель.
        </span>
      </el-form-item>
    </el-form-item>

    
    
  </div>
</div>
<div class="calculator__extraServises__inner">
  
  <div class="calculator__extraServise left-side" v-if="false">
    
    <div class="container__item">

      <el-form-item>
        <el-form-item prop="services.dataForTheDriver" class="calculator__toggle">
          <div class="calculator__toggle-title">Нужны данные на водителя<span class="question" data-text=""></span></div>
          <el-switch v-model="dataForm.services.dataForTheDriver" />
        </el-form-item>

        <el-form-item class="calculator__input calculator__input-driver"
          prop="services.sendTo" v-if="dataForm.services.dataForTheDriver" :required="dataForm.services.dataForTheDriver">
          <el-select v-model="dataForm.services.sendTo" placeholder="Выбрать"
            :disabled="!dataForm.services.dataForTheDriver">
            <el-option v-for="communication in communications" :key="communication.value"
              :label="communication.label" :value="communication.value" />
          </el-select>
        </el-form-item>

      </el-form-item>
    </div>
  </div>

  <!-- <div class="calculator__extraServise calculator__extraServise_w_full p-releative" :class='(cargoSpaceTab.errorNatureOfCargo) ? "error-nature" : ""'>
    <el-form-item 
      class="calculator__input_type_package"
      type="text"
      label="Характер груза"
    >
      <el-select
        v-model="cargoSpaceTab.natureOfCargo"
        placeholder="Выбрать"
        filterable
        v-cancel-read-only
        autocomplete="do-not-autofill"
        value-key='id'
        @click="cargoSpaceTab.errorNatureOfCargo = false"
      >
        <el-option
          v-for="(nature, index) in natures"
          :key="index"
          :label="nature.title"
          :value="nature"
        />
      </el-select>
      <div class="error-label">Пожалуйста выберите характер груза</div>
    </el-form-item>
  </div> -->

  <div class="calculator__extraServise calculator__extraServise_w_full p-releative" :class='(cargoSpaceTab.errorNatureOfCargo) ? "error-nature" : ""'>
    <el-form-item 
      class="calculator__input_type_package calculator__input_valid_required"
      type="text"
      label="Характер груза"
    >
      <el-select
        v-model="cargoSpaceTab.natureOfCargo"
        placeholder="Выбрать"
        filterable

        default-first-option
        reserve-keyword
        :filter-method="filterOptionsTab"

        v-cancel-read-only
        autocomplete="do-not-autofill"
        value-key='id'

        @click="cargoSpaceTab.errorNatureOfCargo = false"
      >
        <el-option
          v-for="(nature, index) in fnatures"
            :key="`$${nature.title}-${nature.value}`"
            :label="nature.title"
            :value="nature"
            class="show-natures"
        />
      </el-select>
      <div class="error-label">
        {{cargoSpaceTab.errorNatureOfCargo}}
      </div>
    </el-form-item>
  </div>

  <div class="add-packaging">
    <div class="add-packaging__title calculator__cargo__cost-title">
      Дополнительная упаковка
    </div>
    <div class="calculator-addition-package-space">
      <div
        class="calculator__additionalPackaging__buttons js-calculator__additionalPackaging__buttons active-toggle">
        <el-form-item
          :prop="'packagesTabs.' + cargoSpaceTab.counter + '.additionalPackagingGroup'"
          :rules="getPackagesRules(cargoSpaceTab.counter)">
          <el-checkbox-group v-model="dataForm.packagesTabs[cargoSpaceTab.counter].additionalPackagingGroup">
            <el-checkbox-button v-for="(type, index) in dataForm.packagesTabs[cargoSpaceTab.counter].typeOfPackagings.value"
              :key="type.id"
              :label="type.title"
              :value="type.id"
              @change="refreshPackages(type.id)"
              :disabled="type.isLocked && requiredNeeded()">

              <template #reference>
                {{ type.label }}
              </template>
            </el-checkbox-button>
          </el-checkbox-group>
        </el-form-item>
      </div>
    </div>
  </div>


</div>


